var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box d-flex align-items-center justify-content-between"},[_c('h4',{staticClass:"ms-2 mb-0 font-size-18 ion-text-primary"},[_vm._v(_vm._s(_vm.$t(`menu.${_vm.title}`)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }